import styled from 'styled-components';

import { theme } from '../layout/theme';
import { size } from '../layout/helpers';

export const Content = styled.div`
  line-height: 1.5;
  font-size: 16px;

  &.limit-width {
    max-width: ${theme.distances.contentMaxWidth};
  }

  &.text-alt {
    color: ${theme.colors.text.alt};
  }

  > * {
    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    margin-top: ${size(4)};
    margin-bottom: ${size(2)};
    color: ${theme.colors.text.main};
  }

  p {
    margin: ${size(2)} 0;
  }

  ul,
  ol {
    margin: ${size(2)} 0;
    padding-left: ${size(4)};
  }

  a {
    text-decoration: none;
    color: ${theme.colors.text.link};

    &:hover {
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
  }

  ${theme.screens.Md} {
    font-size: 18px;
    &.smaller {
      font-size: 16px;
    }
  }
`;
